<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>密码设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="box">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="用户名" prop="name">
          <el-input v-model="form.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="旧密码" prop="old_pwd">
          <el-input v-model="form.old_pwd"  type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_pwd">
          <el-input v-model="form.new_pwd"  type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirm_pwd">
          <el-input v-model="form.confirm_pwd"  type="password" show-password></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="submit('ruleForm')" class="modify">确认修改</el-button>
    </div>
  </div>
</template>
<script>
import {getDistributorTwoInfo,updatePwd} from '@/request/index.js'
  export default{
    data(){
      return{
        form:{
          token:window.sessionStorage.getItem('Token'),
          name:'',
          new_pwd:'',
          old_pwd:"",
          confirm_pwd:''
        },
        rules: {
          new_pwd: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
          ],
          old_pwd: [
            { required: true, message: '请输入旧密码', trigger: 'blur' }
          ],
          confirm_pwd: [
            { required: true, message: '请输入确认新密码', trigger: 'blur' }
          ]
        }
      }
    },
    created(){
      this.getInfo()
    },
    methods:{
      getInfo(){
        let data = {
          token:window.sessionStorage.getItem('Token'),
        }
        getDistributorTwoInfo(data).then(res=>{
          console.log(res)
          if(res.data.status=='ok'){
            this.form.name = res.data.result.user_name 
          }
        })
      },
      submit(form){
        if(this.form.new_pwd==this.form.old_pwd){
          this.$message.error('新密码与旧密码一致')
          return false
        }
        if(this.form.new_pwd!=this.form.confirm_pwd){
            this.$message.error('新密码与确认新密码不一致')
            return false
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            updatePwd(this.form).then(res=>{
              if(res.data.status=='ok'){
                this.$message.success('密码修改成功')
                this.form = {
                  token:window.sessionStorage.getItem('Token'),
                  name:this.form.name,
                  new_pwd:'',
                  old_pwd:"",
                  confirm_pwd:''
                }
              }else{
                this.$message.error(res.data.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }
</script>
<style lang="less" scoped>
.box{
  height: 810px;
  width: 100%;
  background: #fff;
  margin-top: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.modify{
  margin-top: 20rem;
}
/deep/ .el-input{
  width: 60rem;
}
/deep/ .el-input input{
  background: #fff !important;
}
/deep/ .el-button{
  background: #006AFA;
}
</style>